import { RelUserRolePermissions } from 'src/app/core/models/role.model';
import { IServiceProviderAlertType } from 'src/app/core/models/service-provider.model';
import { User } from 'src/app/core/models/user.model';
import { Venue } from 'src/app/core/models/venue.model';

// This file defines the type of the state for the user store.
// UserStoreState interface defines a state with a user property of type User
// initialUserStoreState provides the initial state for the user store, setting user to null

export interface UserStoreState {
  user: User | null;
  permissions: RelUserRolePermissions[];
  advancedSupport: boolean;
  alertTypes: IServiceProviderAlertType[];
  venueDetails: Venue | null;
  isContextSwitching: boolean;
}

// Initial user store state
export const initialUserStoreState: UserStoreState = {
  user: null,
  permissions: [],
  advancedSupport: false,
  alertTypes: [],
  venueDetails: null,
  isContextSwitching: false,
};
